export function runOnBrowserIdle(cb: () => void) {
  if (window.requestIdleCallback) {
    return window.requestIdleCallback(cb);
  }

  setTimeout(cb, 200);
}
